<template>
  <v-navigation-drawer
    v-model="drawer"
    temporary
    right
    width="450"
    height="100%"
    app
  >
    <v-card flat>
      <v-card-title>
        {{ adding ? 'Add Output' : output.name }}
      </v-card-title>
      <v-card-subtitle>
        <template v-if="adding"> Add your output here </template>
        <v-row
          v-else
          dense
        >
          <v-col cols="auto"> <span class="font-weight-bold">Id</span> {{ output.id }} </v-col>
        </v-row>
      </v-card-subtitle>
      <v-divider v-if="!adding" />
      <v-card-text>
        <v-form
          ref="form"
          v-model="valid"
        >
          <v-row>
            <v-col cols="12">
              <v-text-field
                v-model="output.name"
                label="Name"
                outlined
                hide-details="auto"
                :rules="[$rules.required]"
              />
            </v-col>
            <v-col
              v-if="output.imposition"
              cols="12"
            >
              <v-select
                v-model="output.imposition.id"
                :items="impositions"
                item-text="name"
                item-value="id"
                label="Imposition"
                clearable
                outlined
                hide-details="auto"
              />
            </v-col>
            <v-col
              v-if="output.optimizationProfile"
              cols="12"
            >
              <v-select
                v-model="output.optimizationProfile.id"
                :items="optimization_profiles"
                item-text="name"
                item-value="id"
                label="Optimization Profile"
                clearable
                outlined
                hide-details="auto"
              />
            </v-col>
            <v-col cols="12">
              <v-textarea
                v-model="output.description"
                label="Description"
                outlined
                hide-details="auto"
                :rules="[$rules.required]"
              />
            </v-col>
            <v-col cols="12">
              <v-textarea
                v-model="output.notes"
                hide-details="auto"
                label="Admin Notes"
                outlined
              />
            </v-col>
            <v-col cols="12">
              <v-switch
                v-model="output.includeBleed"
                label="Include Bleed"
                color="primary"
                inset
                hide-details
                outlined
              />
            </v-col>
            <v-col cols="12">
              <v-switch
                v-model="output.includeGuides"
                label="Include Guides"
                color="primary"
                inset
                hide-details
                outlined
              />
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
    </v-card>
    <template #append>
      <div class="px-3 py-5">
        <v-btn
          color="primary"
          block
          large
          :loading="saving"
          @click="save"
        >
          Save
        </v-btn>
      </div>
    </template>
  </v-navigation-drawer>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
  name: 'EditOutput',

  components: {},

  data() {
    return {
      loading: false,
      valid: false,
      saving: false,
      drawer: false
    };
  },

  computed: {
    adding() {
      return !this.output.id;
    },
    output: {
      get() {
        return this.$store.getters['outputs/edit_output'];
      },
      set(val) {
        this.$store.dispatch('outputs/edit', val);
      }
    },
    ...mapGetters({
      impositions: 'lookup/impositions',
      optimization_profiles: 'lookup/optimization_profiles'
    })
  },

  async mounted() {
    this.$bus.$off(this.$enums.EVENT_BUS_EVENTS.EDIT_OUTPUT_SHOW);
    this.$bus.$on(this.$enums.EVENT_BUS_EVENTS.EDIT_OUTPUT_SHOW, (data) => {
      this.loadData(data.id);
      this.drawer = true;
    });
  },

  methods: {
    loadData(id) {
      this.loading = true
      ;(id
        ? this.$store.dispatch('outputs/get', id)
        : this.$store.dispatch('outputs/set', {
          imposition: {},
          optimizationProfile: {},
          active: 1
        })
      )
        .catch((error) => {
          this.logError(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    async save() {
      if (!this.$refs.form.validate()) return;
      this.saving = true;
      this.$store
        .dispatch('outputs/save', this.output)
        .then(() => {
          this.drawer = false;
          this.$emit('save');
        })
        .catch((error) => {
          this.logError(error);
        })
        .finally(() => {
          this.saving = false;
        });
    }
  }
};
</script>
